import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";

export class CategoryList extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return '/product-category/list';
    }

    protected navigate(event: any) {
        event.preventDefault();
        let id = event.target.closest('tr').getAttribute('data-id');
        super.navigate(event, '/product-category/edit/' + id);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const navigate = this.navigate,
            params: {} | any = this.getFormData();

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'id', defaultValue: params?.id}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'name', defaultValue: params?.name}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Select {...{
                                    id: 'status',
                                    basic: 'show-all',
                                    items: ['active', 'inactive'],
                                    defaultValue: params?.status
                                }}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'parent', defaultValue: params?.parent}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'client', defaultValue: params?.client}}/>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'id:a'}/>

                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['product-categories']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="c.id">
                                    # <i className="bi bi-sort-down-alt"></i>
                                </th>

                                <th className="sortable" data-sortkey="c.`name`">
                                    {this.dictionary.get['name']}
                                </th>

                                <th className="sortable" data-sortkey="c.`status`">{this.dictionary.get['status']}</th>

                                <th className="sortable" data-sortkey="p.`name`">
                                    {this.dictionary.get['parent']}
                                </th>

                                <th className="sortable" data-sortkey="product_count">
                                    {this.dictionary.get['product_count']}
                                </th>

                                <th className="sortable"
                                    data-sortkey="client.`name`">{this.dictionary.get['client']}</th>

                                <th className="sortable" data-sortkey="c.created_at">
                                    {this.dictionary.get['created']}
                                </th>
                                <th className="sortable" data-sortkey="c.created_at">
                                    {this.dictionary.get['updated']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                let createdAt = '-', updatedAt = '-';
                                if (elem.created_at) {
                                    createdAt = (new Date(elem.created_at + ' GMT')).toLocaleString();
                                }
                                if (elem.updated_at) {
                                    updatedAt = (new Date(elem.updated_at + ' GMT')).toLocaleString();
                                }
                                return (
                                    <tr key={elem.id} data-id={elem.id} onMouseDown={navigate}>
                                        <td style={{textAlign: 'right'}}>{elem.id}.</td>
                                        <td>{elem.name}</td>
                                        <td>{elem.status}</td>
                                        <td>{elem.parent ?? '-'}</td>
                                        <td>{elem.product_count}</td>
                                        <td>{elem.clientName}</td>
                                        <td>{createdAt}<br/>{elem.created_by}</td>
                                        <td>{updatedAt}<br/>{elem.updated_by}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={8}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
